import React from "react";
import PropTypes from "prop-types";

/**
 * Shown on the form instead of "Manager" and "Accountant in charge" when the requester
 * is in Accounting (Settings → Signers → Accountant, or the Chief Accountant): they do
 * the accountant's work themselves, so the request goes straight to the Chief Accountant
 * (or to Head of Finance when the Chief Accountant raises it).
 */
const AccountingRaisedNotice = ({ chief = false, className = "" }) => (
  <div role="note" className={`tw-rounded-geist-md tw-border tw-border-solid tw-border-geist-border tw-bg-geist-bg-2 tw-p-3 ${className}`}>
    <p className="tw-m-0 tw-text-sm tw-font-semibold tw-text-geist-fg">Raised by Accounting</p>
    <p className="tw-m-0 tw-mt-1 tw-text-[13px] tw-text-geist-fg-2">
      No Manager or accountant in charge: you prepare the ERP journal yourself (ERP journals tab, after saving).
      Approval: <strong>{chief ? "Head of Finance → BOD" : "Chief Accountant → Head of Finance → BOD"}</strong>.
    </p>
  </div>
);

AccountingRaisedNotice.propTypes = {
  chief: PropTypes.bool,
  className: PropTypes.string,
};

export default AccountingRaisedNotice;
